import { getCoachPremiumPage } from 'constants/pages';
import Pencil from 'svg/Pencil';
import VideoCamera from 'svg/VideoCamera';
import Button, { ButtonLink } from 'components/Button';
import CardsSection from 'components/CardSection';
import NoDataPlaceholder from 'components/DiscoverPage/NoDataPlaceholder';
import PremiumContentCard from 'components/Premium/PremiumContentCard';
import EditButton from './EditButton';
import { PremiumSectionProps } from '../types';

const PremiumSection: React.FC<PremiumSectionProps> = ({
  onSubscribe,
  onEditPremiumPrice,
  onUploadContent,
  isOwner,
  coachId,
  premiumCoachContent,
  isPlayerSubscribedToPremium,
  premiumContentLoading,
  canCoachEditInfo,
}) => {
  const subscriptionPrice =
    premiumCoachContent?.userProfiles?.[0]?.priceUnitAmountPremiumContentDefault;
  const isSubscriptionEnabledFromCoach =
    typeof subscriptionPrice === 'number' && subscriptionPrice > 0;
  return (
    <section className="mt-ds-2xl">
      <div className="flex items-center gap-2">
        <h2 className="typography-product-heading-compact-desktop mb-2">Premium content</h2>
        {canCoachEditInfo && <EditButton onClick={onEditPremiumPrice} className="ml-auto" />}
      </div>
      <span className="typography-product-body">
        {premiumCoachContent?.userProfiles?.[0]?.premiumContentDescription || ''}
      </span>
      {!premiumContentLoading && premiumCoachContent?.userContentFiles.length == 0 && (
        <NoDataPlaceholder text="Coach hasn't uploaded any content yet" className="mt-ds-xl" />
      )}
      <CardsSection
        className="mt-ds-xl"
        gap="1rem"
        loading={premiumContentLoading}
        visibleCards={{ base: 1, xs: 1, sm: 2, md: 3, xl: 3 }}
        scrollOffset={{ base: 0, xs: 100, sm: 0 }}
        renderCard={(entity) => (
          <PremiumContentCard vertical coachId={coachId} entity={entity} responsive={false} />
        )}
        data={premiumCoachContent?.userContentFiles || []}
      />
      <div className="mt-10 flex justify-end gap-3">
        {premiumCoachContent!?.userContentFiles.length > 0 && (
          <ButtonLink
            href={getCoachPremiumPage(coachId)}
            variant="secondary"
            className="w-fit"
            size="md"
          >
            Show more
          </ButtonLink>
        )}
        {isOwner ? (
          <div className="hidden gap-3 max-lg:flex">
            <Button
              variant="brand"
              iconLeft={<VideoCamera className="h-4 w-4" />}
              className="w-fit"
              size="md"
              onClick={onUploadContent}
            >
              Upload Video
            </Button>
            <Button
              iconLeft={<Pencil className="h-4 w-4" />}
              variant="primary"
              className="w-fit"
              size="md"
              onClick={onEditPremiumPrice}
            >
              Edit Price
            </Button>
          </div>
        ) : (
          isSubscriptionEnabledFromCoach &&
          isPlayerSubscribedToPremium === false && (
            <Button variant="brand" className="w-fit" size="md" onClick={onSubscribe}>
              Subscribe
            </Button>
          )
        )}
      </div>
    </section>
  );
};

export default PremiumSection;
